'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbstractGraph = function () {
  function AbstractGraph() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        start = _ref.start,
        items = _ref.items,
        downwardsMap = _ref.downwardsMap,
        loopbackMap = _ref.loopbackMap,
        positionMap = _ref.positionMap,
        upwardsMap = _ref.upwardsMap,
        layerMap = _ref.layerMap,
        layerArr = _ref.layerArr,
        dummyArr = _ref.dummyArr,
        edges = _ref.edges;

    _classCallCheck(this, AbstractGraph);

    this.start = start;
    this.items = items;

    this.downwardsMap = downwardsMap || {};
    this.loopbackMap = loopbackMap || {};
    this.positionMap = positionMap || {};
    this.upwardsMap = upwardsMap || {};
    this.layerMap = layerMap || {};
    this.layerArr = layerArr || [];
    this.dummyArr = dummyArr || [];
    this.edges = edges || [];
  }

  _createClass(AbstractGraph, [{
    key: 'resetMaps',
    value: function resetMaps() {
      this.downwardsMap = {};
      this.loopbackMap = {};
      this.positionMap = {};
      this.upwardsMap = {};
      this.layerMap = {};
      this.layerArr = [];
      this.dummyArr = [];
      this.edges = [];
    }
  }, {
    key: 'buildDownwardsMap',
    value: function buildDownwardsMap() {
      var _this = this;

      var nodeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.start;
      var ancestorTree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var node = this.items[nodeId];
      var lastNodeId = nodeId;
      var ancestors = ancestorTree && [].concat(ancestorTree) || [];
      ancestors.push(lastNodeId);
      this.downwardsMap[lastNodeId] = this.downwardsMap[lastNodeId] || [];

      if (node && node.next && node.next.length > 0) {
        _lodash2.default.each(node.next, function (nextId) {
          _this.downwardsMap[lastNodeId] = _this.downwardsMap[lastNodeId] || [];
          _this.downwardsMap[lastNodeId].push(nextId);
          if (_this.downwardsMap[nextId] === undefined) {
            _this.buildDownwardsMap(nextId, ancestors);
          } else if (_lodash2.default.includes(ancestors, nextId)) {
            _this.loopbackMap[lastNodeId] = _this.loopbackMap[lastNodeId] || [];
            _this.loopbackMap[lastNodeId].push(nextId);
          }
        });
      }
    }
  }, {
    key: 'buildUpwardsMap',
    value: function buildUpwardsMap() {
      var _this2 = this;

      _lodash2.default.each(this.downwardsMap, function (childrenIds, parentId) {
        _this2.upwardsMap[parentId] = _this2.upwardsMap[parentId] || [];
        _lodash2.default.each(childrenIds, function (childId) {
          _this2.upwardsMap[childId] = _this2.upwardsMap[childId] || [];
          _this2.upwardsMap[childId].push(parentId);
        });
      });
    }
  }, {
    key: 'buildLayerMap',
    value: function buildLayerMap() {
      var _this3 = this;

      var nodeOrder = [];
      this.layerArr = [];
      this.layerMap = {};

      var recursive = function recursive() {
        var nodeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.start;
        var layerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        if (_this3.layerMap[nodeId] === undefined || _this3.layerMap[nodeId] < layerId) {
          _this3.layerMap[nodeId] = layerId;
        }

        if (!_lodash2.default.includes(nodeOrder, nodeId)) {
          nodeOrder.push(nodeId);
          _lodash2.default.each(_this3.downwardsMap[nodeId], function (childId) {
            if (!_lodash2.default.includes(_this3.loopbackMap[nodeId], childId)) {
              recursive(childId, layerId + 1);
            }
          });
        }
      };

      recursive();

      _lodash2.default.each(nodeOrder, function (nodeId) {
        var layerId = _this3.layerMap[nodeId];
        _this3.layerArr[layerId] = _this3.layerArr[layerId] || [];
        _this3.layerArr[layerId].push(nodeId);
      });
    }
  }, {
    key: 'buildEdgeMap',
    value: function buildEdgeMap() {
      var _this4 = this;

      var hasAddedDummies = false;

      var addDummyNode = function addDummyNode(parentId, childId) {
        var dummyNodeId = 'D' + (0, _utils.uuid6)();

        var indexOfChildId = _this4.downwardsMap[parentId].indexOf(childId) || 0;
        _this4.downwardsMap[parentId] = _this4.downwardsMap[parentId] || [];
        _this4.downwardsMap[parentId].splice(indexOfChildId, !!childId ? 1 : 0, dummyNodeId);
        _this4.downwardsMap[dummyNodeId] = [];
        _this4.upwardsMap[dummyNodeId] = [parentId];
        _this4.dummyArr.push(dummyNodeId);

        if (childId !== undefined) {
          var indexOfParentId = _this4.upwardsMap[childId].indexOf(parentId);
          _this4.upwardsMap[childId] = _this4.upwardsMap[childId] || [];
          _this4.upwardsMap[childId].splice(indexOfParentId, 1, dummyNodeId);
          _this4.downwardsMap[dummyNodeId] = [childId];
        }

        hasAddedDummies = true;
      };

      _lodash2.default.each(_extends({}, this.downwardsMap), function (childIds, parentId) {
        var parentLayerId = _this4.layerMap[parentId];
        if (childIds.length > 0) {
          _lodash2.default.each(childIds, function (childId) {
            var childLayerId = _this4.layerMap[childId];
            if (childLayerId - parentLayerId > 1) addDummyNode(parentId, childId);
          });
        } else if (parentLayerId < _this4.height - 1) {
          addDummyNode(parentId);
        }
      });

      return hasAddedDummies;
    }
  }, {
    key: 'buildPositionMap',
    value: function buildPositionMap() {
      var _this5 = this;

      this.loopLayersDown(function (_ref2) {
        var nodeId = _ref2.nodeId,
            layerIndex = _ref2.layerIndex,
            nodeIndex = _ref2.nodeIndex,
            layer = _ref2.layer;

        _this5.setBasePosition({ nodeId: nodeId, layerIndex: layerIndex, nodeIndex: nodeIndex, layer: layer });
      });

      var iterations = 0;
      var MAX_ITERATIONS = 100;
      do {
        iterations++;
        this.movement = false;
        this.loopLayersDown(function (_ref3) {
          var nodeId = _ref3.nodeId;

          _this5.setXPosition(nodeId, _this5.getXPosition({ nodeId: nodeId }));
        });
        this.loopLayersUp(function (_ref4) {
          var nodeId = _ref4.nodeId;

          _this5.setXPosition(nodeId, _this5.getXPosition({ nodeId: nodeId }));
        });
      } while (this.movement === true && iterations < MAX_ITERATIONS);

      // Final pass to fix misaligned nodes
      this.loopLayersDown(function (_ref5) {
        var nodeId = _ref5.nodeId;

        _this5.setXPosition(nodeId, _this5.getStraightenedPosition({ nodeId: nodeId }));
      });
    }
  }, {
    key: 'findPaths',
    value: function findPaths(firstId, lastId) {
      var _this6 = this;

      var allPaths = [];
      var traverse = function traverse(nodeId) {
        var ancestors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var nodeNotTraversed = !ancestors.includes(nodeId);
        if (nodeNotTraversed) {
          ancestors.push(nodeId);
          if (nodeId === lastId) {
            allPaths.push(ancestors);
          } else {
            _lodash2.default.each(_this6.downwardsMap[nodeId], function (nextId) {
              return traverse(nextId, [].concat(_toConsumableArray(ancestors)));
            });
          }
        }
      };
      traverse(firstId);

      return allPaths;
    }
  }, {
    key: 'buildEdges',
    value: function buildEdges() {
      var _this7 = this;

      _lodash2.default.each(this.items, function (item, itemId) {
        _lodash2.default.each(item.next, function (nextId) {
          var paths = _this7.findPaths(itemId, nextId);
          if (paths !== undefined && paths.length > 0) {
            _this7.edges.push({
              prevId: itemId,
              nextId: nextId,
              path: _lodash2.default.map(paths[0], function (id) {
                return _this7.positionMap[id];
              })
            });
          }
        });
      });
    }
  }, {
    key: 'setItems',
    value: function setItems(items, start) {
      this.start = start;
      this.items = items;
    }
  }, {
    key: 'build',
    value: function build() {
      var _this8 = this;

      if (this.start === undefined || this.items === undefined) {
        throw new Error('GraphJS: `items` and `start` must be set before calling build.');
      }
      // TODO: check for changes before rebuilding.
      this.resetMaps();
      this.buildDownwardsMap();
      this.buildUpwardsMap();
      this.buildLayerMap();
      while (this.buildEdgeMap()) {
        this.buildLayerMap();
      }
      this.buildPositionMap();
      this.buildEdges();

      this.items = _lodash2.default.mapValues(this.items, function (item, key) {
        return _extends({}, item, { pos: _this8.positionMap[key]
        });
      });
    }
  }, {
    key: 'width',
    get: function get() {
      return _lodash2.default.max(_lodash2.default.map(this.layerArr, 'length'));
    }
  }, {
    key: 'height',
    get: function get() {
      return this.layerArr.length;
    }
  }, {
    key: 'length',
    get: function get() {
      return _lodash2.default.size(this.items);
    }
  }]);

  return AbstractGraph;
}();

exports.default = AbstractGraph;
module.exports = exports['default'];